import type { Variants } from 'framer-motion';

export const titleSection: Variants = {
  initial: { opacity: 0, x: '-2vw' },
  animate: { opacity: 1, x: '0', transition: { ease: 'easeInOut' } },
  exit: { opacity: 0, x: '2vw' },
};

export const btnRightSection: Variants = {
  initial: { opacity: 0, x: '2vw' },
  animate: { opacity: 1, x: '0', transition: { ease: 'easeInOut' } },
  exit: { opacity: 0, x: '-2vw' },
};

export const cardInOut: Variants = {
  initial: {
    opacity: 0,
    scale: 0.95,
    y: 50,
    transition: {
      duration: 0.15,
      // ease: [0.6, -0.05, 0.01, 0.99],
    },
  },
  animate: i => ({
    opacity: 1,
    scale: 1,
    y: 0,
    transition: {
      delay: 0.03 * i,
      duration: 0.15,
      y: { type: 'spring', stiffness: 550, damping: 30 },
      // ease: [0.6, -0.05, 0.01, 0.99],
      // type: 'spring', stiffness: 120,
    },
  }),
  exit: i => ({
    opacity: 0,
    scale: 0.9,
    y: 5,
    transition: {
      delay: 0.05 * i,
      duration: 0.15,
      y: { type: 'spring', stiffness: 300, damping: 30 },
      // ease: [0.6, -0.05, 0.01, 0.99],
    },
  }),
};
